import { render, staticRenderFns } from "./RegisterTerminalTef.vue?vue&type=template&id=13051f66"
import script from "./RegisterTerminalTef.vue?vue&type=script&lang=js"
export * from "./RegisterTerminalTef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports